// extracted by mini-css-extract-plugin
module.exports = {"App":"App__App__2y9L2","App-logo":"App__App-logo__2kH7u","App-logo-spin":"App__App-logo-spin__3SPup","App-header":"App__App-header__1CT6T","App-link":"App__App-link__3_zO5"};